// extracted by mini-css-extract-plugin
export default {"loading":"Error_loading__ToSQO","img_wrapper":"Error_img_wrapper__4orvN","header":"Error_header__ycNYP","desc":"Error_desc__7xbYo"};